import React from "react";
import { graphql } from "gatsby";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArrowIcon from "../modules/ArrowIcon";
import Hero from "./Hero";
function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <ArrowIcon />
    </div>
  );
}

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <ArrowIcon />
    </div>
  );
}
export default function Slideshow({ data }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    dotsClass: "slick-dots custom-indicator flex items-center justify-center",
  };
  return (
    <Slider {...settings}>
      {data.slides.map((slide) => (
        <div className="flex flex-col" key={slide.id}>
          <Hero data={slide} />
        </div>
      ))}
    </Slider>
  );
}

export const slideshowQuery = graphql`
  fragment SlideShowComponent on DatoCmsSlideshow {
    internal {
      type
    }
    id
    slides {
      internal {
        type
      }
      id
      callToActionButtonLink
      callToActionButtonText
      backgroundImage {
        alt
        format
        gatsbyImageData
        video {
          mp4Url
          thumbnailUrl(format: jpg)
        }
      }
      heroText
      heroSubText
      textColor
      youtubeEmbedUrl
    }
  }
`;
